import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { AgeVerificationRoutingModule } from './age-verification-routing.module';
import { AgeVerificationComponent } from './components/age-verification/age-verification.component';
import { AgeVerificationEffects } from './store/age-verification.effects';
import { AgeVerificationFeature } from './store/age-verification.slice';

@NgModule({
  declarations: [AgeVerificationComponent],
  imports: [
    CommonModule,
    AgeVerificationRoutingModule,
    StoreModule.forFeature(AgeVerificationFeature),
    EffectsModule.forFeature([AgeVerificationEffects]),
    SharedModule,
  ],
})
export class AgeVerificationModule {}
